import { isEmpty } from "lodash";
import useFirebase from "../../../../../useFirebase";
import { setShowMessage, setErrorInfo } from "../../../AxiosRtk/successMessage";
import { useDispatch, useSelector } from "react-redux";
// import { setRulesData } from "../../../AxiosRtk/DashBoard";

function useCallsAndSms(device, callsAndSmsData, setCallsAndSmsData) {
  const { getCollectionData, postCollectionData, createCollectionData } = useFirebase();
  const dispatch = useDispatch();
  const { setRulesData } = useSelector(({ setRules }) => setRules);

  function callFireStore(payload) {
    const newPayload = {
      setRulesActiveInActiveStatus: { ...setRulesData?.setRulesActiveInActiveStatus, callsAndSMSMonitoringEnabled: payload?.callSmsActivate ? true : false },
      callAndSmsMonitoring: payload
    }

    if (setRulesData) {
      postCollectionData(device, newPayload);
    } else {
      createCollectionData(device, newPayload);
    }
    getCollectionData(device);
  }

  function handleToggleChange(e) {
    const { name, checked } = e.target;
    const collectionPayload = {
      ...callsAndSmsData,
    };

    if (name === "CALLS_AND_SMS_ACTIVATE") {
      collectionPayload["callSmsActivate"] = checked ? 1 : 0;
    } else if (name === "ALLOW_TO_READ_SMS_CONTENT") {
      collectionPayload["allowMeToReadSMSContent"] = checked ? 1 : 0;
    } else if (name === "MONITOR_UNKNOWN_NUMBERS") {
      collectionPayload["monitorUnknownNumbers"] = checked ? 1 : 0;
    } else if (name === "BLOCK_UNKNOWN_NUMBERS") {
      collectionPayload["blockUnknownNumbers"] = checked ? 1 : 0;
    }
    callFireStore(collectionPayload);
  }

  function handleAllSelect(e, activeTab) {
    const { checked } = e.target;
    if (!isEmpty(callsAndSmsData)) {
      let contacts = [...callsAndSmsData?.contacts];
      if (activeTab === 'ALLOW_BLOCK_CONTACTS') {
        contacts = contacts?.map((item) => {
          const tempObj = { ...item };
          // if (parseInt(tempObj?.contactID) === parseInt(id)) {
          tempObj['isChecked'] = checked
          // }
          return tempObj;
        })
      } else {
        contacts = contacts?.map((item) => {
          const tempObj = { ...item };
          // if (parseInt(tempObj?.contactID) === parseInt(id)) {
          tempObj['callMonitored'] = checked ? 1 : 0
          // }
          return tempObj;
        })
      }

      const payload = {
        ...callsAndSmsData,
        contacts: [...contacts]
      };

      setCallsAndSmsData(payload);
    }
  }

  function handleCheckBoxChange(e, activeTab) {
    const { id, checked } = e.target;
    if (!isEmpty(callsAndSmsData)) {
      let contacts = [...callsAndSmsData?.contacts];

      if (activeTab === 'ALLOW_BLOCK_CONTACTS') {
        contacts = contacts?.map((item) => {
          const tempObj = { ...item };
          if (parseInt(tempObj?.contactID) === parseInt(id)) {
            tempObj['isChecked'] = checked
          }
          return tempObj;
        })
      } else {
        contacts = contacts?.map((item) => {
          const tempObj = { ...item };
          if (parseInt(tempObj?.contactID) === parseInt(id)) {
            tempObj['callMonitored'] = checked ? 1 : 0
          }
          return tempObj;
        })
      }

      const payload = {
        ...callsAndSmsData,
        contacts: [...contacts]
      };

      setCallsAndSmsData(payload);
    }
  }

  function handleCallsAndSmsStatusChange(status) {
    console.log("status ==>>", status)

    let contacts = [...callsAndSmsData?.contacts];
    if (status === 'ALLOW' || status === 'BLOCK') {
      const contactIsChecked = contacts?.filter((item) => item?.isChecked);
      if (contactIsChecked?.length === 0) {
        dispatch(setErrorInfo({
          errorInfo: true,
          title: "PLS_CHECK_ITEM",
          defaultTitle: "Please check items"
        }))
        return;
      }
    }


    if (status === "ALLOW") {
      contacts = contacts?.map((item) => {
        const obj = { ...item };
        if (obj["isChecked"]) {
          obj["callBlocked"] = 0;
          delete obj["isChecked"];
        }
        return obj;
      });
    } else if (status === "BLOCK") {
      contacts = contacts?.map((item) => {
        const obj = { ...item };
        if (obj["isChecked"]) {
          obj["callBlocked"] = 1;
          delete obj["isChecked"];
        }
        return obj;
      });
    } else {
      contacts = contacts?.map((item) => {
        const obj = { ...item };
        if (obj["isChecked"]) {
          // obj["callMonitored"] = 1;
          delete obj["isChecked"];
        }
        return obj;
      });
    }
    // console.log(contacts)
    const collectionPayload = {
      ...callsAndSmsData,
      contacts: [...contacts],
    };

    callFireStore(collectionPayload);

    if (status === "ALLOW") {
      dispatch(setShowMessage({
        showMessage: true,
        defaultMessage: "Call and Sms allowed successfully",
        message: "CALL_SMS_ALLOWED_SUCCESS_MSG"
      }))
    } else if (status === "BLOCK") {
      dispatch(setShowMessage({
        showMessage: true,
        defaultMessage: "Call and Sms blocked successfully",
        message: "CALL_SMS_ALLOWED_BLOCK_MSG"
      }))
    } else {
      dispatch(setShowMessage({
        showMessage: true,
        defaultMessage: "Data saved successfully",
        message: "DATA_SAVED"
      }))
    }
  }

  return {
    handleToggleChange,
    handleAllSelect,
    handleCheckBoxChange,
    handleCallsAndSmsStatusChange,
  };
}

export default useCallsAndSms;
